import type { WorkspaceShellDefinition, WorkspaceShellId } from './workspaceShellTypes.js';
import { renderProfessionalWorkspaceShell } from './ProfessionalWorkspaceShell.js';
import { renderMissionControlWorkspaceShell } from './MissionControlWorkspaceShell.js';

export const WORKSPACE_SHELLS: Record<WorkspaceShellId, WorkspaceShellDefinition> = {
  professional: {
    id: 'professional',
    label: 'Professional UI',
    description: 'Default BIM OPS productivity shell with sidebar, top bar, route workspace, and shared floating windows.',
    status: 'available',
    render: renderProfessionalWorkspaceShell,
  },
  'mission-control': {
    id: 'mission-control',
    label: 'Mission Control',
    description: 'Reserved future immersive 3D cockpit shell. It will consume the same route slots, services, windows, dialogs, notifications, and persistence layer.',
    status: 'reserved',
    render: renderMissionControlWorkspaceShell,
  },
};

export function resolveWorkspaceShell(id: WorkspaceShellId): WorkspaceShellDefinition {
  return WORKSPACE_SHELLS[id] ?? WORKSPACE_SHELLS.professional;
}
